export const ProductAccessStates = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
  EXPIRED: 'expired',
  INACTIVE: 'inactive',
  PENDING: 'pending',
};
